import { AsyncPipe} from '@angular/common';
import { Component, inject } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Observable } from 'rxjs';
import { Evenement } from '../../models/evenement.class';
import { CarteAgendaComponent } from "../carte-agenda/carte-agenda.component";
@Component({
  selector: 'app-agenda',
  imports: [AsyncPipe, CarteAgendaComponent],
  templateUrl: './agenda.component.html',
  styleUrl: './agenda.component.scss'
})

export class AgendaComponent {
  apiService: ApiService = inject(ApiService);
  events$: Observable<Evenement[]> = this.apiService.getEvenements();
  ngOnInit(): void {
    this.events$.subscribe((e) => console.log(e))
  }
}
